module.exports = __webpack_public_path__ + "754c947186b76057cc45f5f40b0b08a1.svg";